/** Куда вести после входа и нужен ли «замок» онбординга. Чистые функции без сети. */

export type OnboardingState = {
  onboarding_gate: boolean | null;
  onboarding_completed_at: string | null;
  /** Профиль для знакомств заполнен (meetProfileReady). Нет данных — считаем заполненным. */
  meet_ready?: boolean;
};

export const SETUP_PATH = "/profile/setup";
const ARENA_PATH = "/arena";

function isArenaPath(path: string): boolean {
  const p = path.split(/[?#]/)[0].replace(/\/+$/, "");
  return p === ARENA_PATH || p.startsWith(`${ARENA_PATH}/`);
}

function mustOnboard(state: OnboardingState | null | undefined): boolean {
  return !!state?.onboarding_gate && !state.onboarding_completed_at;
}

/**
 * Новый (строгий) пользователь без завершённого мастера — в мастер; ссылку-приглашение
 * НЕ трогаем, её заберёт финал мастера. Иначе — сохранённая ссылка или /home.
 */
export function resolvePostAuthDestination(
  state: OnboardingState | null | undefined,
  consumeIntent: () => string | null,
  peekIntent?: () => string | null,
): string {
  if (mustOnboard(state)) {
    // Пришёл со страницы ARENA — возвращаем туда: там короткий мастер ARENA вместо полного.
    const peek = peekIntent?.();
    if (peek && isArenaPath(peek)) return consumeIntent() ?? ARENA_PATH;
    return SETUP_PATH;
  }
  return consumeIntent() ?? "/home";
}

/** Разделы, закрытые замком: Знакомство (/people без режима экспертов) и Кофе. */
export function isMeetLockedPath(pathname: string, search?: Record<string, unknown> | null): boolean {
  const p = pathname.replace(/\/+$/, "") || "/";
  if (p === "/people") {
    const e = search?.["experts"];
    const experts = e === true || e === 1 || e === "1" || e === "true" || !!search?.["category"];
    return !experts;
  }
  return p === "/coffee" || p.startsWith("/coffee/");
}

/**
 * Замок: только Знакомство и Кофе, только для новых (gate) пользователей,
 * пока профиль для знакомств не заполнен. Остальные разделы доступны сразу.
 */
export function needsOnboarding(
  state: OnboardingState | null | undefined,
  pathname: string,
  search?: Record<string, unknown> | null,
): boolean {
  if (!state?.onboarding_gate || state.meet_ready !== false) return false;
  return isMeetLockedPath(pathname, search);
}

/** Мини-мастер «Знакомство» с возвратом туда, откуда открыли. */
export function meetSetupHref(returnTo: string): string {
  const safe = returnTo.startsWith("/") && !returnTo.startsWith("//") ? returnTo : "/people";
  return `${SETUP_PATH}?mode=meet&return=${encodeURIComponent(safe)}`;
}

/** Безопасный путь возврата из мини-мастера. */
export function safeReturnPath(raw: string | null | undefined, fallback = "/people"): string {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//") || raw.startsWith(SETUP_PATH)) return fallback;
  return raw;
}
